import * as Sentry from '@sentry/react'
import type * as React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorBoundaryView } from './ErrorBoundaryView'

export const Area = ({
  children,
  id,
}: {
  children: React.ReactNode
  id: string
}) => {
  Sentry.addBreadcrumb({
    category: 'area',
    message: `area ${id}`,
    level: 'info',
  })

  return (
    <ErrorBoundary
      FallbackComponent={({ error }) => (
        <ErrorBoundaryView error={error} areaId={id} />
      )}
      onError={(error, info) => {
        Sentry.captureException(error, {
          extra: { componentStack: info.componentStack, areaId: id },
        })
      }}
    >
      {children}
    </ErrorBoundary>
  )
}
